import type { Interest } from 'app/types/interest';

export function hashInterestTagId(value: string): number {
  let hash = 0;
  for (let index = 0; index < value.length; index++) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }
  return hash;
}

export function getUserInterestTagIds(userInterests?: Interest[]): string[] {
  return Array.from(new Set((userInterests ?? []).map((interest) => interest.tagId)));
}

function getSeededInterestScore(value: string, seed: string): number {
  let mixedHash = hashInterestTagId(value) ^ hashInterestTagId(seed);
  mixedHash = Math.imul(mixedHash ^ (mixedHash >>> 16), 0x45d9f3b);
  mixedHash = Math.imul(mixedHash ^ (mixedHash >>> 16), 0x45d9f3b);
  return (mixedHash ^ (mixedHash >>> 16)) >>> 0;
}

export function getSeededUserInterestTagIds(interestIds: string[], limit: number, seed: string): string[] {
  return Array.from(new Set(interestIds))
    .sort((left, right) => {
      const leftHash = getSeededInterestScore(left, seed);
      const rightHash = getSeededInterestScore(right, seed);
      if (leftHash === rightHash) return left.localeCompare(right);
      return leftHash - rightHash;
    })
    .slice(0, limit);
}

export function getOrderedGeneralInterestTagIds(userInterests?: Interest[], tags?: { id: string }[]): string[] {
  const interestIds = getUserInterestTagIds(userInterests);
  const interestIdSet = new Set(interestIds);
  const remainingTagIds = (tags ?? [])
    .flatMap((tag) => (interestIdSet.has(tag.id) ? [] : [tag.id]))
    .sort((left, right) => {
      const leftHash = hashInterestTagId(left);
      const rightHash = hashInterestTagId(right);
      if (leftHash === rightHash) return left.localeCompare(right);
      return leftHash - rightHash;
    });
  return remainingTagIds;
}
